import React, { useState, useEffect, useRef } from "react";
import "./App.scss";
import Modal from "./Components/Modal";
import axios from "axios";

function App() {
  const [modalVisible, setModalVisible] = useState(false);
  const [param, setParam] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [waitingOtpApproval, setWaitingOtpApproval] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [merchantName, setMerchantName] = useState(null);
  const [verifyToken, setVerifyToken] = useState();
  const [otpPhone, setPhone] = useState();
  const [otp, setOtp] = useState('');
  const [otpVerifyError, setOtpVerifyError] = useState('');
  const [authedError, setAuthedError] = useState('');

  const mountedRef = useRef(true);
//
const [errorMessage, setErrorMessage] = useState('');
// Add a new state variable to track the loading state
const [isLoading, setIsLoading] = useState(false);
const loadingSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" fill="none" stroke="#FFFFFF" strokeWidth="10" r="35" strokeDasharray="164.93361431346415 56.97787143782138">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
      </circle>
    </svg>
  );
  
const validateInput = () => {
  const isValidInput = /^2567\d{8}$/.test(mobileNumber);

  if (isValidInput || mobileNumber === '') {
    setErrorMessage('');
    setIsButtonDisabled(false);
  } else {
    setErrorMessage('Enter Number starting with 2567....');
    setIsButtonDisabled(true);
  }
};

const handleInputChange = (e) => {
  setMobileNumber(e.target.value);
};

const handleInputOTP = (e) => {
  setOtp(e.target.value);
};

const handleBlur = () => {
  validateInput();
};


//
  useEffect(() => {
    return () => {
      // Set the mountedRef to false when the component is unmounted
      mountedRef.current = false;
    };
  }, []);

  const fetchData = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenParam = urlParams.get('token');
      setVerifyToken(tokenParam);
      if (!tokenParam) {
        // Handle case when token parameter is missing
        setModalVisible(true);
        return;
      }

      const response = await axios.get(`https://envoy.fanitepay.com/cashout/verify?token=${tokenParam}`);

    // Access the first item in the array and set states accordingly
    const firstItem = response.data[0];
    setMerchantName(firstItem.merchantname);
    setPhone(firstItem.phone);
        
      // Check if the response is not successful or has no length
      if (firstItem.isExpired === "Yes") {
        setModalVisible(true);
        return;
      }
      if (!response || !response.data || response.data.length === 0) {
        setModalVisible(true);
        return;
      }

      // Update param only if it's not already set
      if (!param) {
        setParam(tokenParam);
      }

      setModalVisible(true); // Show modal after fetching data
    } catch (error) {
      // Handle error
      //console.error('Error fetching data:', error);
      setModalVisible(true);
    }
  };

useEffect(() => {
  fetchData();
}, [param, setModalVisible]); // Add param to the dependency array to update only when param changes

  const handlePayButtonClick = async (e) => {
    e.preventDefault();

    // Check if token parameter exists
    if (!param) {
      // Handle case when token parameter is missing
      setModalVisible(true);
      return;
    }
      // Set loading state to true
      setIsLoading(true);
    // Prepare data to send to the webhook
    const postData = {
      phone: mobileNumber,
      // Add any other data you want to send
    };
  
    try {
      // Send data to the webhook using Axios
      const response = await axios.post("https://envoy.fanitepay.com/otp", postData);
  
      // Check if the component is still mounted before updating state
      if (!mountedRef.current) return;

      // Show Waiting Approval
      setWaitingOtpApproval(true);
    } catch (error) {
      //console.error("Error sending data to webhook:", error);
    } finally {
    // Reset loading state after the operation
    setIsLoading(false);
  }
  };

  const handleOtpButtonClick = async (e) => {
    e.preventDefault();
  
    // Check if token parameter exists
    if (!param) {
      // Handle case when token parameter is missing
      setModalVisible(true);
      return;
    }
      // Set loading state to true
      setIsLoading(true);
    // Prepare data to send to the webhook
    const postData = {
      code: otp,
      // Add any other data you want to send
    };
  
    try {
      // Send data to the webhook using Axios
      const response = await axios.post("https://api.fanitepay.com/otpverify", postData);
  
      // Check if the component is still mounted before updating state
      if (!mountedRef.current) return;
  
      const resToken = response.data.token;
      setWaitingOtpApproval(true);
      
      try {
        // Send data to the authed webhook using Axios
        const authedResponse = await axios.post("https://api.fanitepay.com/cashout/authed", {
          token: resToken,
          verifyToken: verifyToken,
        });
  
        if (authedResponse.status === 200 && authedResponse.data.success) {
          // Transaction is successful, setTransactionComplete to true
          setTransactionComplete(true);
        } else {
          // Handle other cases if needed
          console.error("Transaction failed or authed response not successful:", authedResponse);
          const authedErrorMessage = authedResponse.data.error || "Transaction failed. Please try again.";
          setAuthedError(authedErrorMessage);
        }
      } catch (authedError) {
        console.error("Error in authed:", authedError);
        setAuthedError("Insufficient Balance.");
      }
    } catch (otpVerifyError) {
      console.error("Error in OTP verification:", otpVerifyError);
      const otpVerifyErrorMessage = otpVerifyError.response?.data?.error || "Error in OTP verification. Please check your OTP and try again.";
      setOtpVerifyError(otpVerifyErrorMessage);
    } finally {
      // Reset loading state after the operation
      setIsLoading(false);
    }
  };
  return (
    <div className="App">
    <Modal show={modalVisible} close={() => setModalVisible(false)} title={param ? "Dynamic Title" : "Error"}>
      {param && !waitingOtpApproval && (
        // Modal content when token is available and Waiting Approval is not visible
        <main className="flex flex-col p-7 space-y-4 w-full">
            <section className="header container--row container__col-md-12" title="Mobile Money" data-v-53ce5f6b data-v-47b9326c>
                  <div className="header__details" data-v-53ce5f6b>
                      <div className="merchant__details" data-v-53ce5f6b>
                          <img className="merchant__details-logo" src="https://res.cloudinary.com/dr6nn6thq/image/upload/v1691355133/thumbnail_imp2ef.png" alt="merchant-logo" data-v-53ce5f6b />
                      </div>
                      <div className="customer__details" data-v-53ce5f6b>
                          <div className="customer__details-money" data-v-53ce5f6b>
                             <p data-v-53ce5f6b>{merchantName}</p>
                          </div>
                      </div>
                  </div>
                  <div className="dcc__info" data-v-53ce5f6b>
                  </div>
              </section>
              <div className="flex justify-center items-center max-h-full ">
                <div className="space-y-4 w-full h-full py-2">
                  <div className="space-y-4 mt-1">
                <form className="space-y-8">
                      <div className="space-y-6">
                        <div className="flex flex-col space-y-1 relative overflow-visible">
                          <label htmlFor="mobile" className="flex space-x-1 justify-center  text-sm font-medium text-primary-dark">
                          <div className="flex justify-center  text-sm font-medium">Enter your Phone Number <br/><br/>ending {otpPhone}</div></label>
                          <div className="relative">
                            <div className="w-10 overflow-hidden absolute left-3 top-3">
                              <img src='https://res.cloudinary.com/dr6nn6thq/image/upload/v1703330421/Flag-of-Uganda_yyhyak.png' width={34} height={34} alt='operator'/>
                            </div>
                            <div className>
                            <input
                                  value={mobileNumber}
                                  name="mobile"
                                  onChange={handleInputChange}
                                  onBlur={handleBlur}
                                  placeholder={otpPhone}
                                  type="number"
                                  className="appearance-none text-sm rounded-lg border border-gray-200 p-4 pb-3 w-full h-12 outline-primary placeholder:text-gray-300 focus:bg-white pl-14"
                                  maxLength={12}
                                />
                              </div>
                              {errorMessage && (
                                <><br /><p className="text-red-500 text-sm">{errorMessage}</p></>
                              )}
                          </div>
                        </div>
                      </div>
                      <button
                          onClick={handlePayButtonClick}
                          className="flex justify-center bg-peach-light rounded-lg p-3 space-x-1 text-sm text-white w-full font-medium opacity-95 hover:opacity-100"
                          disabled={isButtonDisabled || isLoading} // Disable the button when loading
                        >
                          {isLoading ? (
                                <div className="flex items-center">
                                  {loadingSVG}
                                  <span className="ml-2">Sending OTP...</span>
                                </div>
                              ) : (
                            // Regular button text
                            <span className="mt-px block text-white">Send OTP</span>
                          )}
                        </button>

                      <div className="flex justify-center">
                      <p className="merchant__details-name" data-v-53ce5f6b><img src="https://res.cloudinary.com/dr6nn6thq/image/upload/v1699784620/fanite-logo_pkahti.png"  width={84} height={84} alt='securedby'/></p>
                       </div>
                    </form>
              </div>
              </div>
              </div>
            </main>
      )}

{waitingOtpApproval && !transactionComplete && (
  // Waiting Approval inside the modal
  <main className="flex flex-col p-7 space-y-4 w-full">
    <div className="flex justify-center items-center max-h-full ">
      <div className="space-y-4 w-full h-full py-2">
        <div className="space-y-4 mt-1">
          <div className="overflow-hidden px-8 flex justify-center">
            <img alt="Loading" src="https://res.cloudinary.com/dr6nn6thq/image/upload/v1703350097/password_2_lkprce.png" width="45" />
          </div>
          <form className="space-y-8">
            <p className="text-sm leading-normal text-gray-500 flex justify-center">Enter the 4 digits OTP sent to</p>
            <p className="text-sm leading-normal text-gray-500 flex justify-center">your Email and Phone</p>
            <div className="relative">
              <div className>
                <input
                  name="otp"
                  onChange={handleInputOTP}
                  placeholder=""
                  type="number"
                  max={4}
                  className="appearance-none text-sm rounded-lg border border-gray-200 p-4 pb-3 w-full h-12 outline-primary placeholder:text-gray-300 focus:bg-white pl-14"
                  maxLength={3}
                />
              </div>
            </div>
            {otpVerifyError && (
              <p className="text-red-500 text-sm">{otpVerifyError}</p>
            )}
            <button
              onClick={handleOtpButtonClick}
              className="flex justify-center bg-peach-light rounded-lg p-3 space-x-1 text-sm text-white w-full font-medium opacity-95 hover:opacity-100"
              disabled={isButtonDisabled || isLoading} // Disable the button when loading
            >
              {isLoading ? (
                <div className="flex items-center">
                  {loadingSVG}
                  <span className="ml-2">Verifying...</span>
                </div>
              ) : (
                // Regular button text
                <span className="mt-px block text-white">Verify OTP</span>
              )}
            </button>
            {authedError && (
              <p className="text-red-500 text-sm">{authedError}</p>
            )}
            <div className="flex justify-center">
              <img src="https://res.cloudinary.com/dr6nn6thq/image/upload/v1699784620/fanite-logo_pkahti.png" width={84} height={84} alt='securedby' />
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
)}


      {!param && !waitingOtpApproval && (
        // Error message when token is missing
        <main className="flex flex-col p-7 space-y-4 w-full">
          <div className="flex justify-center items-center max-h-full ">
              <div className="space-y-4 w-full h-full py-2">
                <div className="space-y-4 mt-1">
                <div className="overflow-hidden px-8 flex justify-center">
                   <img alt="Error" src="https://res.cloudinary.com/dr6nn6thq/image/upload/v1699994343/icons8-box-important_ixuyzi.gif" />
                </div>
              <form className="space-y-8">
              <p className="text-sm leading-normal text-gray-500 flex justify-center">Authorization link is Expired.</p>
              <p className="text-sm leading-normal text-purple-700 flex justify-center">Please check again.</p>
              </form>
            </div>
            </div>
            </div>
          </main>
      )}
      
      {transactionComplete && (
        // Transaction Complete Modal
        <main className="flex flex-col p-7 space-y-4 w-full">
          <div className="flex justify-center items-center max-h-full ">
              <div className="space-y-4 w-full h-full py-2">
                <div className="space-y-4 mt-1">
                <div className="overflow-hidden px-8 flex justify-center">
                   <img alt="Congragulations" src="https://res.cloudinary.com/dr6nn6thq/image/upload/v1700002865/success_mffjbf.png" />
                </div>
              <form className="space-y-8">
              <p className="text-sm leading-normal text-gray-500 flex justify-center">Congragulations!!</p>
              <p className="text-sm leading-normal text-purple-700 flex justify-center">Request Approved Successfully</p>
              </form>
            </div>
            </div>
            </div>
          </main>
      )}
    </Modal>
  </div>
  );
}

export default App;
